import { render, staticRenderFns } from "./ContactsAppBar.vue?vue&type=template&id=56045c2f&scoped=true&"
import script from "./ContactsAppBar.vue?vue&type=script&lang=js&"
export * from "./ContactsAppBar.vue?vue&type=script&lang=js&"
import style0 from "./ContactsAppBar.vue?vue&type=style&index=0&id=56045c2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56045c2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTab,VTextField})
